module.exports = __webpack_public_path__ + "img/my-account-b.f7280c01.svg";